<template>
  <div class="sp-walk-in-message" :class="classModifiers">
    <sp-icon
      name="walk-in-filled"
      class="sp-walk-in-message__icon"
      size="s"
      fill-color="var(--icon-fill-color)"
    ></sp-icon>
    <sp-text type="body-bold" class="sp-walk-in-message__text">{{ message }}</sp-text>
    <sp-tooltip v-if="tooltip" :content="tooltip" horizontal-align="right">
      <sp-icon name="help-filled" size="s" class="sp-walk-in-message__tooltip-icon"></sp-icon>
    </sp-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  message: {
    type: String,
    default: undefined,
  },
  align: {
    type: String,
    default: "start",
    validator: (value) => ["start", "center"].includes(value),
  },
  tooltip: {
    type: String,
    default: undefined,
  },
});

const classModifiers = computed(() => ({
  [`--align-${props.align}`]: props.align,
}));
</script>

<style lang="scss">
:host {
  display: block;
  --color: var(--sp-comp-walk-in-message-color, var(--sp-sys-color-open));
  --icon-fill-color: var(--sp-comp-walk-in-message-icon-fill-color, var(--color));
}
</style>

<style lang="scss" scoped>
.sp-walk-in-message {
  display: grid;
  grid-template-columns: auto 1fr auto;
  position: relative;

  &__text {
    color: var(--color);
  }

  &__tooltip-icon {
    margin-left: var(--sp-ref-spacing-2);
  }

  &.--align-center {
    display: inline-grid;
    justify-content: center;
  }
}
</style>
